<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_246_86172)">
<path d="M5.9987 7.99998L7.33203 9.33331L9.9987 6.66665M14.6654 7.99998C14.6654 11.6819 11.6806 14.6666 7.9987 14.6666C4.3168 14.6666 1.33203 11.6819 1.33203 7.99998C1.33203 4.31808 4.3168 1.33331 7.9987 1.33331C11.6806 1.33331 14.6654 4.31808 14.6654 7.99998Z" stroke="#7EB428" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_246_86172">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>

</template>